import React, { useState, useEffect } from "react";
import { Modal, Button, Card, Form, Nav } from "react-bootstrap";
import { api } from "../utils/api";
import MealCard from "./MealCard";
import MealGrid from "./MealGrid";

const Menu = ({ isOpen, onAdd, setIsOpen }) => {
  const [meals, setMeals] = useState([]);
  const [finder, setFinder] = useState({
    f_name: "",
    f_group: "",
  });
  const [page, setPage] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [meal, setMeal] = useState(null);
  const [mealsGroups, setMealsGroups] = useState(null);
  const [recommendation, setRecommendation] = useState(null);

  useEffect(() => {
    api.getRecomendationForMe().then((meals) => {
      setRecommendation(meals);
    });
  }, []);

  useEffect(() => {
    if ((finder.f_name !== "") || (finder.f_group !== "")) return;
    api
      .getMeals({ p: 1, s: 10, f_show_favorites: true, f_activity: true })
      .then(({ meals, totalDocs, groups }) => {
        setMeals(meals);
        setTotalDocs(totalDocs);
        setMealsGroups(groups);
      });
  }, [finder]);

  useEffect(() => {
    setFinder({
      f_name: "",
      f_group: "",
    });
  }, [isOpen]);

  const onMore = () => {
    if ((finder.f_name !== "") & (finder.f_group !== "")) {
      setFinder({
        f_name: "",
        f_group: "",
      });
    }
    setPage(page + 1);
    api
      .getMeals({
        p: page + 1,
        s: 10,
        f_show_favorites: true,
        f_activity: true,
      })
      .then((res) => {
        setMeals([...meals, ...res.meals]);
      });
  };

  useEffect(() => {
    if ((finder.f_name === "") & (finder.f_group === "")) return;
    setPage(1);
    api
      .getMeals({
        ...finder,
        f_show_favorites: true,
        s: 10000,
        f_activity: true,
      })
      .then(({ meals }) => {
        setMeals(meals);
      });
  }, [finder]);

  const addToFavorite = (meal) => {
    api.addToFavorites(meal).then(() => {
      setMeals(
        meals.map((ml) => {
          if (ml._id === meal) {
            return {
              ...ml,
              isFavorite: true,
            };
          } else {
            return ml;
          }
        })
      );
    });
  };

  const deleteFromFavorite = (meal) => {
    api.deleteFromFavorites(meal).then(() => {
      setMeals(
        meals.map((ml) => {
          if (ml._id === meal) {
            return {
              ...ml,
              isFavorite: false,
            };
          } else {
            return ml;
          }
        })
      );
    });
  };

  return (
    <>
      <Modal
        show={isOpen}
        onHide={() => setIsOpen(false)}
        size="xl"
        fullscreen="md"
        centered
        scrollable
        dialogClassName="order-modal menu-modal"
      >
        <Modal.Header closeButton>
          <div className="d-flex flex-column w-100 gap-1">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
              <Modal.Title className="fw-bold">Меню</Modal.Title>
              <div className="chip muted-chip">
                <i className="bi bi-search" />
                Быстрый поиск
              </div>
            </div>
            <p className="m-0 text-muted small">
              Добавляйте блюда в заказ, переключайтесь между группами и избранным.
            </p>
          </div>
        </Modal.Header>
        <Modal.Body className="p-3">
          <div className="glass-panel p-3 mb-3">
            <div className="menu-filters gap-2 align-items-center">
              <Form.Control
                type="text"
                placeholder="Введите название блюда"
                value={finder.f_name}
                onChange={(e) =>
                  setFinder({
                    ...finder,
                    f_name: e.target.value,
                  })
                }
                name="name"
                className="flex-grow-1"
              />
              <div className="menu-filters__actions">
                <Button
                  variant="outline-secondary"
                  onClick={() => setFinder({ f_name: "", f_group: "" })}
                >
                  Сбросить
                </Button>
                <Button
                  variant="outline-primary"
                  onClick={() =>
                    api
                      .getRandomMeal()
                      .then(({ random }) => setFinder({ f_group: "", f_name: random.name }))
                  }
                >
                  Мне повезет!
                </Button>
              </div>
            </div>
            {mealsGroups ? (
              <div className="category-tabs mt-3">
                <div className="category-tabs__wrap">
                  <Nav
                    variant="pills"
                    activeKey={finder.f_group}
                    onSelect={(f_group) => setFinder({ f_name: "", f_group })}
                    className="category-wrap"
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="">Все</Nav.Link>
                    </Nav.Item>
                    {mealsGroups.map((el) => (
                      <Nav.Item key={el}>
                        <Nav.Link eventKey={el}>{el}</Nav.Link>
                      </Nav.Item>
                    ))}
                    <Nav.Item>
                      <Nav.Link eventKey="favorite">
                        <i className="bi bi-bookmark-star-fill me-1" />
                        Избранное
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="menu-grid mt-3">
            {meals
              ? meals.map((meal) => (
                  <MealGrid
                    deleteFromFavorite={deleteFromFavorite}
                    addToFavorite={addToFavorite}
                    meal={meal}
                    setMeal={setMeal}
                    onAdd={onAdd}
                    key={meal._id}
                  />
                ))
              : ""}
          </div>
          {finder.f_name !== "" || finder.f_group !== "" || totalDocs === meals.length ? (
            ""
          ) : (
            <div className="d-flex justify-content-center mt-3">
              <Button onClick={() => onMore()} variant="outline-secondary">
                Показать еще
              </Button>
            </div>
          )}
          {finder.f_group === "favorite" ? (
            recommendation ? (
              <div className="mt-4">
                <h5 className="fw-bold">Возможно вам понравится</h5>
                <div className="card-grid mt-3">
                  {recommendation.map((meal) => (
                    <MealGrid
                      deleteFromFavorite={deleteFromFavorite}
                      addToFavorite={addToFavorite}
                      meal={meal}
                      setMeal={setMeal}
                      onAdd={onAdd}
                      key={meal._id}
                    />
                  ))}
                </div>
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}
        </Modal.Body>
      </Modal>
      <MealCard meal={meal} setMeal={setMeal} onAdd={onAdd} />
    </>
  );
};

export default Menu;
